export default "__VITE_ASSET__C$lUwzDj__"